import { ReactNode } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button, { FictivButtonType } from '~/core/Button'
import getColor from '~/lib/getColor'

const DEFAULT_MODAL_WIDTH = '348px'

type DeleteWarningModalPropsType = {
    body?: ReactNode
    loading?: boolean
    onClose: () => void
    onConfirm?: Function
    onConfirmButtonType?: FictivButtonType
    text: string
    title: string
    visible: boolean
    width?: string
}

const PLACEMENT = 'user-profile-delete-warning-modal'

export default function DeleteWarningModal(props: DeleteWarningModalPropsType) {
    const {
        body,
        loading,
        onClose,
        onConfirm,
        onConfirmButtonType = 'danger',
        text,
        title,
        visible,
        width = DEFAULT_MODAL_WIDTH,
    } = props

    return (
        <Modal
            bodyStyle={{ padding: '24px 12px 12px 24px' }}
            centered
            closable={false}
            footer={null}
            visible={visible}
            onCancel={onClose}
            width={width}
            maskClosable
        >
            <Box>
                <InfoCircleOutlined
                    style={{
                        color: getColor('error'),
                        fontSize: '21px',
                        marginRight: '18px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        fontSize="16px"
                        color="blackAlpha65"
                        style={{ marginBottom: '12px', width: '90%' }}
                    >
                        {title}
                    </Text>
                    {body ? (
                        body
                    ) : (
                        <Text
                            color="blackAlpha65"
                            style={{
                                marginBottom: '48px',
                            }}
                        >
                            This action cannot be undone.
                        </Text>
                    )}
                    <Box justifyContent="end">
                        <Button
                            onClick={onClose}
                            name={`${PLACEMENT}-cancel`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-cancel`}
                            style={{ marginRight: '8px', marginLeft: 'auto' }}
                        >
                            Cancel
                        </Button>
                        <Button
                            type={onConfirmButtonType}
                            onClick={() => {
                                onConfirm?.()
                            }}
                            name={`${PLACEMENT}-confirm`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-confirm`}
                            loading={loading}
                            disabled={loading}
                        >
                            {text}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
